import { Icon, ImageFit } from '@fluentui/react';
import { Image, useClassNames } from '@h2oai/ui-kit';

import {
  IListCellImageClassNames,
  IListCellImageStyles,
  imageStylesListCellImage,
  listCellImageStylesDefault,
} from './ListCellImage.styles';

interface IListCellImageProps {
  iconName?: string;
  imageSrc?: string;
}

export const ListCellImage = ({ iconName, imageSrc }: IListCellImageProps) => {
  const classNames = useClassNames<IListCellImageStyles, IListCellImageClassNames>(
    'ListCellImage',
    listCellImageStylesDefault
  );
  return (
    <div className={classNames.root} data-test="list-cell-image">
      {!imageSrc ? (
        <div className={classNames.icon}>
          <Icon iconName={iconName} />
        </div>
      ) : (
        <Image alt="image" src={imageSrc} imageFit={ImageFit.centerContain} styles={imageStylesListCellImage} />
      )}
    </div>
  );
};
